/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Manage_Storage_Scheduled_ToastInputs */



/**
* | output |
* | --- |
* | "Storage change scheduled." |
*
* @param {Partner_Manage_Storage_Scheduled_ToastInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_manage_storage_scheduled_toast = /** @type {((inputs?: Partner_Manage_Storage_Scheduled_ToastInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Manage_Storage_Scheduled_ToastInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Speicheränderung geplant.")
	return /** @type {LocalizedString} */ ("Storage change scheduled.")
});